import { makeStyles } from "@material-ui/core/styles";

export const useBriefHeaderDataStyles = makeStyles(() => ({
  longTitle: {
    "font-size": "1.8rem !important",
    "line-height": "2rem",
  },
}));
